import { toLower } from 'lodash';
import styles from './AppTitle.module.scss';
import PrintIcon from '@public/images/print.svg';
import { useTranslation } from 'next-i18next';

const AppTitle = ({ Title, routerPath }: any) => {
    const { t } = useTranslation();
    const betTypeStyle = styles[toLower(routerPath[1])] || '';
    const infoStyle = toLower(routerPath[0]) === 'info' ? styles[toLower(routerPath[0])] : '';
    const showPrint = ['selling-hours'].includes(routerPath[routerPath.length - 1]);
    return (
        <div
            className={`${styles.title} ${betTypeStyle} ${infoStyle} ${
                styles[routerPath[routerPath.length - 1]]
            }`}
        >
            {Title}
            {showPrint && (
                <span
                    className={styles.print}
                    onClick={() => {
                        try {
                            window.print();
                        } catch (e) {
                            console.log(e);
                        }
                    }}
                >
                    <PrintIcon /> <span>{t('Print')}</span>
                </span>
            )}
        </div>
    );
};

export default AppTitle;
